<template>
  <div
    class="calendar-container noselect navigaion-calendar"
  >
    <div
      v-if="showOverlay"
      class="calendar-overlay"
    >
      <v-container fill-height>
        <v-row class="align-center">
          <v-col cols="12">
            <v-btn
              block
              class="csr-btn"
              @click.prevent="navigateToObjectBookingForm(selectedObject)"
            >
              {{ $t('check_availability') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div
      v-if="plusMonths"
      class="calendar-nav"
    >
      <b>{{ monthNameFirstUpperCase }} {{ yearNumber }}</b>
    </div>
    <v-container
      v-else
      class="mt-0 px-1 calendar-nav noselect"
    >
      <v-row no-gutters>
        <v-col class="shrink">
          <v-btn
            small
            icon
            :disabled="showOverlay"
            @click="prevMonth"
          >
            <v-icon small> fa-chevron-circle-left </v-icon>
          </v-btn>
        </v-col>
        <v-col class="grow extra-dense-input px-1 year-month-select">
          <v-select
            v-model="selectedYearAndMonth"
            :items="yearsAndMonths"
            :disabled="showOverlay"
            label=""
            style="font-size: 13px"
            return-object
            outlined
            hide-details
            dense
          ></v-select>
        </v-col>
        <v-col class="shrink">
          <v-btn
            :disabled="showOverlay"
            small
            icon
            @click="nextMonth"
          >
            <v-icon small> fa-chevron-circle-right </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <div id="calendar-container">
      <table
        class="calendar"
        :style="mobile ? 'width: 100%;' : ''"
      >
        <colgroup>
          <col class="esmaspäev" />
          <col class="teisipäev" />
          <col class="kolmapäev" />
          <col class="neljapäev" />
          <col class="reede" />
          <col class="laupäev" />
          <col class="pühapäev" />
        </colgroup>
        <thead>
          <tr>
            <th
              v-for="(nullval, index) in [...Array(7)]"
              :key="index"
              :title="index"
            >
              {{ weekDayLetter(index) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="week in Object.keys(monthWeekDays)"
            :key="week"
          >
            <!-- td class="pad">{{ week }}</td -->
            <td
              v-for="dayOfWeek in Object.keys(monthWeekDays[week])"
              :key="dayOfWeek"
              :class="dayClass(monthWeekDays[week][dayOfWeek])"
              :title="monthWeekDays[week][dayOfWeek].dayText"
              v-html="dayValue(monthWeekDays[week][dayOfWeek])"
              @click="
                selectDateFromNavigationCalendar(monthWeekDays[week][dayOfWeek])
              "
            ></td>
            <!-- td
              v-for="dayOfWeek in Object.keys(monthWeekDays[week])"
              :key="dayOfWeek + '_z'"
              :class="dayClass(monthWeekDays[week][dayOfWeek])"
              v-html="monthWeekDays[week][dayOfWeek].dayDate"
              </td>
             -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import helper from '../../methods/helper'
import Vue from 'vue'
import sharedMethods from '../../methods/sharedMethods'
import moment from 'moment'
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'
import calendarComputed from '@/components/calendarComputed'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'CalendarNavigation',

  data: () => {
    return {
      firstWeekNumber: null,
      lastWeekNumber: null,
      firstDay: null,
    }
  },

  props: {
    plusMonths: {
      type: Number,
      default: 0,
    },
    showOverlay: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...calendarComputed,

    monthNameFirstUpperCase() {
      return helper.firstLetterUppercase(this.monthName.toLowerCase())
    },

    selectedYear: {
      get() {
        return this.calendarYear
      },
      set(val) {
        this.calendarYear = val
      },
    },

    selectedMonth: {
      get() {
        return this.calendarMonth
      },
      set(val) {
        this.calendarMonth = val
      },
    },

    computedMonth() {
      return moment(this.calendarYear + '-' + this.calendarMonth + '-01')
        .add(this.plusMonths, 'month')
        .format('MM')
    },

    computedYear() {
      return moment(this.calendarYear + '-' + this.calendarMonth + '-01')
        .add(this.plusMonths, 'month')
        .format('YYYY')
    },

    monthName() {
      moment.locale(this.lang)
      return moment(
        this.computedYear + '-' + this.computedMonth + '-01'
      ).format('MMMM')
    },

    yearNumber() {
      moment.locale(this.lang)
      return moment(
        this.computedYear + '-' + this.computedMonth + '-01'
      ).format('YYYY')
    },
  },

  watch: {
    calendarYear(value, before) {
      const month = moment(this.calendarYear + '-' + this.calendarMonth + '-01')
      if (this.isMonthInTheFuture(month)) {
        this.updateWeekNumbers()
      } else {
        this.calendarYear = before
      }
    },

    calendarMonth(value, before) {
      const month = moment(this.calendarYear + '-' + this.calendarMonth + '-01')
      if (this.isMonthInTheFuture(month)) {
        this.updateWeekNumbers()
      } else {
        this.calendarMonth = before
      }
    },

    lang(value) {
      moment.locale(value)
    },
  },

  created() {
    moment.locale((this.$route.params && this.$route.params.lang) || 'en')
    this.updateWeekNumbers()
  },

  methods: {
    ...sharedMethods,

    isMonthInTheFuture(month) {
      return month.format('YYYYMM') >= moment().format('YYYYMM')
    },

    selectDateFromNavigationCalendar(day) {
      if (day.day.format('YYYYMMDD') < moment().format('YYYYMMDD')) {
        return
      }
      const date = day.dayDate
      if (this.$route.name === 'calendar') {
        return
      }
      if (!this.searchFilters.dateStart || this.searchFilters.dateEnd) {
        // Set date start
        const canBookThatDate =
          !this.selectedObject ||
          !this.selectedObject.bookedDays ||
          !this.selectedObject.bookedDays[date]
        if (canBookThatDate) {
          Vue.set(
            this.searchFilters,
            'dateStart',
            moment(date).format('DD.MM.YYYY')
          )
          Vue.set(this.searchFilters, 'dateEnd', null)
        }
      } else if (
        moment(date) > moment(helper.dateToYMD(this.searchFilters.dateStart))
      ) {
        const prevDate = moment(date).subtract(1, 'day').format('YYYY-MM-DD')
        const canBookThatDate =
          !this.selectedObject ||
          !this.selectedObject.bookedDays ||
          !this.selectedObject.bookedDays[prevDate]
        if (!this.checkIfPeriodCanBeBooked(date)) {
          Vue.set(this.searchFilters, 'dateStart', null)
          Vue.set(this.searchFilters, 'dateEnd', null)
        } else if (canBookThatDate) {
          Vue.set(
            this.searchFilters,
            'dateEnd',
            moment(date).format('DD.MM.YYYY')
          )
        }
      }
    },

    checkIfPeriodCanBeBooked(endDate) {
      let day = moment(helper.dateToYMD(this.searchFilters.dateStart))
      while (
        day.format('YYYYMMDD') <
        moment(endDate).subtract(1, 'day').format('YYYYMMDD')
      ) {
        day = day.add(1, 'day')
        const canBookThatDate =
          !this.selectedObject ||
          !this.selectedObject.bookedDays ||
          !this.selectedObject.bookedDays[day.format('YYYY-MM-DD')]
        if (!canBookThatDate) {
          return false
        }
      }
      return true
    },

    nextMonth() {
      const nextMonth = moment(
        this.calendarYear + '-' + this.calendarMonth + '-01'
      ).add(1, 'month')
      if (
        parseInt(nextMonth.format('YYYY')) <=
        parseInt(moment().format('YYYY')) + 2
      ) {
        this.calendarYear = nextMonth.format('YYYY')
        this.calendarMonth = nextMonth.format('MM')
      }
    },

    prevMonth() {
      const prevMonth = moment(
        this.calendarYear + '-' + this.calendarMonth + '-01'
      ).subtract(1, 'month')
      if (this.isMonthInTheFuture(prevMonth)) {
        this.calendarYear = prevMonth.format('YYYY')
        this.calendarMonth = prevMonth.format('MM')
      }
    },

    dayValue(day) {
      if (!day.sameMonth) {
        return '&nbsp;'
      }
      return day.dayNumber
    },

    // TODO - refactor. duplicate in CalendarDatePicker.vue
    dayClass(day) {
      const classes = []
      if (!day || !day.sameMonth) {
        return 'pad'
      }
      if (day.isSelected) {
        classes.push('selected-day')
      }
      if (day.today) {
        classes.push('today')
      }
      if (day.passed) {
        classes.push('passed')
      }
      // booked....
      const bookedStatus = this.dayIsBooked(day.dayDate)
      const previousDay = moment(day.dayDate)
        .subtract(1, 'day')
        .format('YYYY-MM-DD')
      const previousDayStatus = this.dayIsBooked(previousDay)
      if (['confirmed', 'archived', 'owner'].includes(bookedStatus)) {
        if (!previousDayStatus) {
          classes.push('pm_booked')
        } else {
          classes.push('booked')
        }
      } else if (bookedStatus === 'new') {
        if (!previousDayStatus) {
          classes.push('pm_onhold')
        } else {
          classes.push('onhold')
        }
      } else {
        // Check if previous day was booked
        if (['confirmed', 'archived', 'owner'].includes(previousDayStatus)) {
          classes.push('am_booked')
        } else if (['new'].includes(previousDayStatus)) {
          classes.push('am_onhold')
        }
      }
      // console.log('_', day.dayDate, classes, day.isSelected)
      return classes.join(' ')
    },

    dayIsBooked(date) {
      if (this.selectedObject && this.selectedObject.bookedDays) {
        if (this.selectedObject.bookedDays[date]) {
          return this.bookingStatuses[this.selectedObject.bookedDays[date]]
        }
      }
      return false
    },

    weekDayLetter(index) {
      return moment().startOf('isoWeek').add(index, 'days').format('dd')
    },

    updateWeekNumbers() {
      this.firstDay = this.computedYear + '-' + this.computedMonth + '-01'
      this.firstWeekNumber = moment(
        this.computedYear + '-' + this.computedMonth + '-01'
      ).format('w')
      this.lastWeekNumber = moment(this.firstDay).endOf('month').format('w')
    },
  },
}
</script>

<style lang="scss">
.calendar-container {
  margin-top: 12px;
  margin-bottom: 8px;
  position: relative;
}
.calendar-overlay {
  background: rgba(255, 255, 255, 0.75);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
}
#calendar-nav-prev {
  margin-right: 4px !important;
}
#calendar-nav-next {
  margin-left: 4px !important;
}
#calendar-nav-month {
  margin-right: 2px !important;
}
.navigaion-calendar {
  .year-month-select {
    max-width: calc(100% - 60px);
  }
}
</style>
